import React, { useRef } from "react";
import PropTypes from "prop-types";

// eslint-disable-next-line no-unused-vars
const Answer = ({ register, index, label, value, name, id, className }) => {
  const inputRef = useRef();
  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <div
      className="flex items-center mb-5"
      onClick={() => {
        inputRef.current.click();
        inputRef.current.checked = true;
      }}
    >
      <input
        ref={(ref) => {
          register(ref);
          inputRef.current = ref;
        }}
        name={name}
        id={id}
        value={Number(value)}
        className="form-radio"
        type="radio"
        index={index}
      />
      <label
        className="form-label"
        htmlFor={id}
        dangerouslySetInnerHTML={{ __html: label }}
      >
      </label>
    </div>
  );
};

Answer.defaultProps = {
  className: "",
  isChecked: false,
};

Answer.propTypes = {
  register: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  className: PropTypes.string,
  isChecked: PropTypes.bool,
};
export default Answer;
